import {
  formatError,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
} from '../../services/AuthService.js';

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const TRADING_PORTAL_CREATED_ACTION = '[trading portal] created';
export const TRADING_PORTAL_VERIFIED_ACTION = '[trading portal] verified';
export const TRADING_PORTAL_LOADED_ACTION = '[trading portal] loaded';

export function signupAction(email, password, navigate) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, response.data.expiresIn * 1000, navigate);
        dispatch(confirmedSignupAction(response.data));
        navigate('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response?.data) || 'Error desconocido';
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  localStorage.removeItem('userDetails');
  navigate('/page-login');
  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, navigate) {
  return (dispatch) => {
    login(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, response.data.expiresIn * 1000, navigate);
        dispatch(loginConfirmedAction(response.data));
        navigate('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response?.data) || 'Error desconocido';
        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}

export function tradingPortalCreatedAction(portalData) {
  return {
    type: TRADING_PORTAL_CREATED_ACTION,
    payload: portalData,
  };
}

export function tradingPortalVerifiedAction() {
  return {
    type: TRADING_PORTAL_VERIFIED_ACTION,
  };
}

export function tradingPortalLoadedAction(portalData) {
  return {
    type: TRADING_PORTAL_LOADED_ACTION,
    payload: portalData,
  };
}






